// стили согласно включенным модулям ui-grid в app.js (насколько они все нужны не проверено)
// имена файлов грида для версии 4.12.0
import "angular-ui-grid/css/ui-grid.core.min.css";
import "angular-ui-grid/css/ui-grid.pagination.min.css";
import "angular-ui-grid/css/ui-grid.expandable.min.css";
import "angular-ui-grid/css/ui-grid.resizeColumns.css";
import "angular-ui-grid/css/ui-grid.cellNav.css";
import "chartist/dist/chartist.min.css";
// это пропатченный материал!
import '@root/css/angular-material.min.css';

import 'angular';
import 'angular-route';
import 'angular-animate';
import 'angular-aria';
import 'angular-messages';
import 'angular-sanitize';
// это пропатченный материал!
import '@root/js/libs/angular-material.min.js';
import 'angular-gettext';
import 'angular-ui-grid';
import 'angular-bind-html-compile';
import 'ng-file-upload';
import Chartist from 'chartist';
window.Chartist = Chartist;
window.moment = require('moment-timezone');
/***
 * не катит, хотя версия NPM идентичная - 1.1.1
 * import 'angular-chart.js';
 * require('angular-chart.js/dist/angular-chart.min.js');
 * копирование из node_modules помогает
 ***/
require('@root/js/libs/angular-chart.min.js');
import postscribe from 'postscribe';
window.postscribe = postscribe;
window.md5 = require('md5');

/***
 * https://github.com/lugin-dev/truescrollbar
 * в mainController.js есть $scope.initScrollBars() и можно  ng-init="initScrollBars()"
 * в main.less классы .tbs-...
 * пока проблема сколла для md-select
 ***/
import TrueScrollBar from '@lugindev/truescrollbar';
window.TrueScrollBar = TrueScrollBar;
import '@lugindev/truescrollbar/src/TrueScrollBar.min.css';

/***
 * https://github.com/Grsmto/simplebar
 * эта либа лучше показала себя для глобальной прокрутки страницы
 * и для левого меню
 * использование также в mainController.js $scope.initScrollBars()
 */
import SimpleBar from 'simplebar';
window.SimpleBar = SimpleBar;
import 'simplebar/dist/simplebar.css';

